import { Fragment, useEffect, useState } from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import TestimonyProgramContainer from '../../../Component/Learning/TestimonyProgram/TestimonyProgramDetail/TestimonyProgramContainer';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { handleGetDetailTestimonyProgram } from 'Component/Learning/TestimonyProgram/TestimonyProgramUtils';
import { setDetail } from 'Features/Learning/TestimonyProgram/testimonyProgramSlice';
import { fetchTestimonyProgram } from 'Features/Learning/TestimonyProgram/Utils/TestimonyProgramUtils';

const TestimonyProgramDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const filters = useSelector(state => state.testimonyProgram.filters)
  const [refetch, setRefetch] = useState(false);

  useEffect(() => {
    if (id) {
      const newFilters = {
        ...filters,
        "filter[id]": id,
        "page": 1,
        "include": "staticAssets,mainPrograms"
      };
      dispatch(fetchTestimonyProgram(newFilters))
        .then((response) => {
          // Kode yang akan dijalankan setelah fetch sukses
          handleGetDetailTestimonyProgram(dispatch, response.payload.data[0], setDetail)
          // Kode lain yang perlu dijalankan setelah fetch sukses
        })
        .catch((error) => {
          // Tangani error jika fetch gagal
          console.error('Error during fetchMemberships:', error);
        });
    }
  }, [id, refetch]);

  return (
    <Fragment>
      <Breadcrumbs mainTitle="Detail Testimony Program" parent="Learning" title="Detail Testimony Program" />
      <TestimonyProgramContainer setRefetch={setRefetch} />
    </Fragment>
  );
};
export default TestimonyProgramDetail;